import EmblaCarousel from "embla-carousel";
import {post} from "../modules/ajax";
import {onVisible} from "../../scripts/Tools/visible-element-observer";
import {fireClickEvent} from "../modules/events";
import {isDesktop} from "../modules/devices";
import {isPremiumUser} from "./user";
import {getWishListItems, updateWishListButton} from "./wishlist";
import {ga4TrackSimpleEvent, getClientId, getUserId, itemDatalayerPush} from "../modules/analytics";
import {getLoaderHtml, hideModal} from "./modal";

export async function renderFullView(search, filters = [])
{
    return new Promise(async resolve => {
        let container = isDesktop() ? document.querySelector('.desktop .header-searcher') : document.querySelector('.mobile .header-searcher')
        let resultsContainer = container.querySelector('.searcher-results');
        let response = await getView({search: search, filters: filters, page: 1, renderView: 'full'});

        if (response.view) resultsContainer.innerHTML = response.view;

        if (response.attributionToken) {
            sessionStorage.setItem('attributionToken', response.attributionToken);
        } else {
            sessionStorage.removeItem('attributionToken');
        }

        try {
            const isFiltersEmpty = (filters == null) || (Array.isArray(filters) && filters.length === 0) || (typeof filters === 'object' && !Array.isArray(filters) && Object.keys(filters).length === 0);

            if (isFiltersEmpty) {
                ga4TrackSimpleEvent(
                    {
                        event: 'searcher',
                        search_term: search,
                        method: 'vertex'
                    }
                );
                ga4TrackSimpleEvent(
                    {
                        event: 'search',
                        search_term: search
                    }
                );
            }
        } catch (error) {
            // Nothing to do
        }

        if (response.success) {
            onVisible(resultsContainer.querySelectorAll('.product .embla-carousel:not(.embla-initialized)'), (slider) => initSlider(slider, {
                loop: true,
                align: 'start'
            }), 0.1);
            onVisible(resultsContainer.querySelectorAll('.load-more-results'), (button) => fireClickEvent(button, true), 0.05);
            onVisible(resultsContainer.querySelectorAll(".fire-product-datalayer"), (element) => itemDatalayerPush('view_item_list', element));
            updateExclusivePremiumProducts();
            updateWishlistButtons();

            resultsContainer.querySelectorAll('button[data-bs-toggle="collapse"]').forEach(function (collapse) {
                new Collapse(collapse, {toggle: false});
            });

            resolve();
        } else {
            resultsContainer.querySelectorAll('.recommender.embla-carousel').forEach((recommender) => initSlider(recommender, {
                loop: true,
                align: 'start',
                slidesToScroll: 'auto'
            }));

            resolve();
        }
    });
}

export async function renderProducts(search, filters, page, pageToken, action = 'append')
{
    return new Promise(async resolve => {
        let container = isDesktop() ? document.querySelector('.desktop .header-searcher') : document.querySelector('.mobile .header-searcher')
        let productsContainer = container.querySelector('.searcher-results .products-container .product-list');
        let response = await getView({search: search, filters: filters, page: page, pageToken: pageToken, renderView: 'products'});

        if (action === 'append') productsContainer.insertAdjacentHTML('beforeend', response.view);
        onVisible(productsContainer.querySelectorAll('.product .embla-carousel:not(.embla-initialized)'), (slider) => initSlider(slider, {loop: true, align: 'start'}), 0.1);
        onVisible(productsContainer.querySelectorAll('.load-more-results'), (button) => fireClickEvent(button, true));
        onVisible(productsContainer.querySelectorAll(".fire-product-datalayer"), (element) => itemDatalayerPush('view_item_list', element));
        updateExclusivePremiumProducts();
        updateWishlistButtons();
        resolve();
    });
}

export function openResults()
{
    let container = isDesktop() ? document.querySelector('.desktop .header-searcher') : document.querySelector('.mobile .header-searcher')
    let resultsContainer = container.querySelector('.searcher-results');

    document.body.style.overflow = 'hidden';
    if (resultsContainer.classList.contains('d-none')) resultsContainer.classList.remove('d-none');
    showCloseButton();
}

export function closeResults()
{
    let container = isDesktop() ? document.querySelector('.desktop .header-searcher') : document.querySelector('.mobile .header-searcher')
    let resultsContainer = container.querySelector('.searcher-results');

    document.body.style.overflow = '';
    if (!resultsContainer.classList.contains('d-none')) resultsContainer.classList.add('d-none');
    hideCloseButton();
}

let ajax = null;
function getView(data)
{
    return new Promise(resolve => {
        if (ajax) ajax.abort();
        data['device'] = isDesktop() ? 'desktop' : 'mobile';
        data['visitorId'] = getClientId();
        data['userId'] = getUserId();

        ajax = post(
            '/ajax/website/search',
            data,
            function (response) {
                resolve({view: response.view, success: true, attributionToken: response.attributionToken})
                ajax = null;
            },
            function (response) {
                resolve({view: response.view, success: false})
                ajax = null;
            }
        );
    });
}

function initSlider(slider, options)
{
    let emblaContainer = slider.closest('.embla-container');
    let emblaPrevButton = emblaContainer.querySelector('.embla-prev-button');
    let emblaNextButton = emblaContainer.querySelector('.embla-next-button');
    let emblaCarousel = EmblaCarousel(slider, options);

    emblaPrevButton.addEventListener('click', function(e) {
        e.preventDefault();
        emblaCarousel.scrollPrev();
    });

    emblaNextButton.addEventListener('click', function(e) {
        e.preventDefault();
        emblaCarousel.scrollNext();
    });

    emblaCarousel.on('init', function() {
        if (emblaCarousel.canScrollNext()) emblaNextButton.classList.remove('d-none');
        if (emblaCarousel.canScrollPrev()) emblaPrevButton.classList.remove('d-none');
        slider.classList.add('embla-initialized');
    });

    if (emblaContainer.classList.contains('embla-lazy-load')) {
        //LAZYLOAD FUNCTIONALITY
        let slidesLoaded = [];
        emblaCarousel.on('slidesInView', function() {
            let slidesInView = emblaCarousel.slidesInView().filter((index) => !slidesLoaded.includes(index));

            slidesInView.forEach(function(slideIndex) {
                let slide = emblaCarousel.slideNodes()[slideIndex];
                if (!slide) return;
                let img = slide.querySelector('img');
                let loader = slide.querySelector('.loader');

                img.src = img.dataset.src;
                img.addEventListener('load', function() {
                    loader.classList.add('d-none');
                    slidesLoaded.push(slideIndex);
                });
            });
        });
    }
}

export function showCloseButton()
{
    let container = isDesktop() ? document.querySelector('.desktop .close-searcher-results-container') : document.querySelector('.mobile .close-searcher-results-container');
    if (container.classList.contains('d-none')) container.classList.remove('d-none');
}

export function hideCloseButton()
{
    let container = isDesktop() ? document.querySelector('.desktop .close-searcher-results-container') : document.querySelector('.mobile .close-searcher-results-container');
    if (!container.classList.contains('d-none')) container.classList.add('d-none');
}

function updateExclusivePremiumProducts()
{
    let container = isDesktop() ? document.querySelector('.desktop .header-searcher') : document.querySelector('.mobile .header-searcher')
    let products = container.querySelectorAll('.product.exclusive-premium');
    let isPremium = isPremiumUser();

    if (!products || isPremium) return;

    products.forEach(function(product) {
        product.querySelector('.btn-add-to-cart').classList.add('d-none');
        product.querySelector('.btn-premium-subscribe').classList.remove('d-none');
    });
}

async function updateWishlistButtons()
{
    let wishListItems = await getWishListItems();
    if (!wishListItems) return;
    document.querySelectorAll('.searcher-results .add-item-wish-list').forEach(function(button) {
        if (wishListItems.includes(parseInt(button.dataset.productId))) updateWishListButton(button, true);
    });
}

export function updateQueryParameter(search)
{
    let url = new URL(window.location.href);

    if (search !== '') url.searchParams.set('search', search);
    else url.searchParams.delete('search');

    window.history.pushState({}, '', url);
}

export function openLoader()
{
    let container = isDesktop() ? document.querySelector('.desktop') : document.querySelector('.mobile') ;
    if (container.querySelector('.modal-loader')) return;
    let loader = getLoaderHtml();
    container.querySelector('.searcher-results').insertAdjacentHTML('afterbegin', loader);
}

export function closeLoader()
{
    hideModal('loadingModal');
}